import { render, staticRenderFns } from "./SocketName.vue?vue&type=template&id=09c5c02b&scoped=true&"
import script from "./SocketName.vue?vue&type=script&lang=ts&"
export * from "./SocketName.vue?vue&type=script&lang=ts&"
import style0 from "./SocketName.vue?vue&type=style&index=0&id=09c5c02b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5c02b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
